import {
  create as createConfetti,
  type CreateTypes as Confetti,
  type Options as ConfettiOptions
} from "canvas-confetti";
import { onMounted, type Ref, ref } from "vue";

/**
 * @param canvas The canvas element for the confetti to fire on
 * @param options Base options for `fireConfetti()`. useful if you need to call it multiple times
 */
export function useConfetti(canvas: Ref<HTMLCanvasElement | null>, options?: ConfettiOptions) {
  const colors = ["#00a489", "#007dc6", "#e74c3c", "#f99f3c", "#7f8b98", "#8463ff", "#c91611"];
  const baseOptions = {
    zIndex: 0,
    colors,
    ...options
  } as ConfettiOptions;

  const confetti = ref<Confetti>();

  onMounted(() => {
    if (!canvas.value) {
      return;
    }

    confetti.value = createConfetti(canvas.value, {
      resize: true,
      useWorker: true,
      disableForReducedMotion: true
    });
  });

  const fireConfetti = (options: ConfettiOptions) => {
    if (!confetti.value) {
      return;
    }

    confetti.value({
      ...baseOptions,
      ...options
    });
  };

  return {
    fireConfetti
  };
}
